import * as React from 'react';
import cx from 'classnames';
import wrapStore from '@src/utils/wrap-store';
import ModalContainer from '@src/components/modal-container';
import RedeemModallStore from './store';
import $$tracker from '@src/tracker';

const styles = require('./index.less');
/**
 * 弹窗模板, 可以快速套用修改
 * @param {RemmedModalStore} store
 * @param onClose
 * @returns {JSX.Element}
 * @constructor
 */
const RedeemModal = ({ store, onClose }) => {
  store.use();
  if (onClose) {
    store.onClose = onClose;
  }

  return (
    <ModalContainer modalState={store.isOpen} hideMask>
      <div className={cx(styles.remmedModalModalRoot, store.isActive && styles.remmedModalModalRootAct)}>
        <div className={styles.mask} />
        <div className={styles.content}>
          <div className={styles.headTitle}>{store.modalTitle}</div>
          <div className={styles.cdkeyContentBox}>
            <div className={styles.keyNumber}>{store.cdKey}</div>
            <div
              className={styles.copyBtn}
              onClick={() => {
                const { clickGcylfz, clickGcylqdfz } = $$tracker;
                store.isSteam ? clickGcylqdfz() : clickGcylfz();
                store.copyCdKey();
              }}
            >
              <div className={styles.normal} />
              <div className={styles.hover} />
              <span>复制</span>
            </div>
          </div>
          <div className={styles.tipsContentBox}>
            <div>请前往游戏内XXXX处输入礼包兑换码进行兑换</div>
            <div>*每位用户仅限兑换一次 </div>
          </div>
        </div>
      </div>
    </ModalContainer>
  );
};

export default wrapStore(RedeemModal, RedeemModallStore);
